import { render, staticRenderFns } from "./WrappingMenu.vue?vue&type=template&id=6b6f894e&scoped=true&"
import script from "./WrappingMenu.vue?vue&type=script&lang=ts&"
export * from "./WrappingMenu.vue?vue&type=script&lang=ts&"
import style0 from "./WrappingMenu.vue?vue&type=style&index=0&id=6b6f894e&lang=scss&scoped=true&"
import style1 from "./WrappingMenu.vue?vue&type=style&index=1&id=6b6f894e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f894e",
  null
  
)

export default component.exports